//验证手机号码
export const checkNum = {
  getMessage:field => field + '必须大于0',
  validate: value => {
    return value>0;
  }
}
export const checkNum2 = {
  getMessage:field => field + '必须是数字',
  validate: value => {
    return value.length == 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)
  }
}


// WEBPACK FOOTER //
// ./src/validator/modules/bpm.js